"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggleMiddleware = void 0;
const AbstractAuthorizerMiddleware_1 = require("../Middlewares/AbstractAuthorizerMiddleware");
const debugLog_1 = __importDefault(require("../Utils/debugLog"));
const types_1 = require("../types");
class FeatureToggleMiddleware extends AbstractAuthorizerMiddleware_1.AbstractAuthorizerMiddleware {
    async hasFeature(cognitoId, featureIdentifier) {
        (0, debugLog_1.default)('FeatureToggleMiddleware.hasFeature', { cognitoId, featureIdentifier });
        const isValid = await this.enforcer.enforce(cognitoId, types_1.ACTION_NAME.READ, `feature:${featureIdentifier}`);
        (0, debugLog_1.default)('FeatureToggleMiddleware.hasFeature', isValid ? 'ALLOW' : 'DENY');
        return isValid;
    }
}
exports.FeatureToggleMiddleware = FeatureToggleMiddleware;
//# sourceMappingURL=FeatureToggleMiddleware.js.map